import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
  fetchBaseQuery({
    baseUrl: getAPIURL("/api/users"),
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.accessToken;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  })
);

export const usersApi = createApi({
  reducerPath: "usersApi",
  baseQuery: baseQueryWithRejection,
  tagTypes: [],
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => "/",
      transformResponse: (response) => response.data,
      providesTags: [],
    }),
    getUsersByRoleId: builder.query({
      query: (params) => {
        const queryString = new URLSearchParams(params).toString();
        return `/?${queryString}`;
      },
      transformResponse: (response) => response.data,
    }),
    getCountryUsers: builder.query({
      query: ({ countryId, ...params }) => {
        const tmp = new URLSearchParams();
        if (params.all) {
          tmp.append("all", params.all);
        }
        return `/country-users/${countryId}?${tmp.toString()}`;
      },
      transformResponse: (response) => response.data,
    }),
    getUserById: builder.query({
      query: ({userId}) => `/${userId}`,
      transformResponse: (response) => response.data,
    }),
  }),
});

export const { useGetUsersQuery,
  useGetUsersByRoleIdQuery,
  useLazyGetUsersByRoleIdQuery,
  useGetCountryUsersQuery,
  useLazyGetCountryUsersQuery,
  useGetUserByIdQuery,
  useLazyGetUserByIdQuery,
} = usersApi;
